module.exports = __webpack_public_path__ + "img/greece.e047ec84.svg";